import React from 'react';
import { withStyles } from '@material-ui/core/styles';

 const CloseButton = withStyles(theme => ({
    root: {
        position: 'absolute',
        zIndex: '99999',
        right: "10px",
        top:"5px",
        textAlign : "center",
        fontWeight : "bolder",
        cursor:"pointer"
    }
    
}))(props =>  <span className={props.classes.root} onClick={props.onClose} >X</span>);

CloseButton.defaultProps = {
    onClose : () => {}
}

export default CloseButton;